var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachment2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.778 4.19A3.256 3.256 0 014.028.94c1.777 0 3.25 1.474 3.25 3.25v4.876a2.021 2.021 0 01-2.031 2.031 2.005 2.005 0 01-2.032-2.031V5.003c0-.431.356-.812.813-.812.431 0 .812.38.812.812v4.063c0 .228.178.406.407.406a.418.418 0 00.406-.406V4.19c0-.889-.736-1.625-1.625-1.625A1.62 1.62 0 002.403 4.19v5.281a2.84 2.84 0 002.844 2.844A2.855 2.855 0 008.09 9.472V5.003c0-.431.356-.812.813-.812.431 0 .812.38.812.812v4.47a4.46 4.46 0 01-4.468 4.468 4.443 4.443 0 01-4.47-4.469V4.191z",
    fill: "#0D2976"
  })));
}
export default SvgAttachment2;